const getRawObjectId = (id) => id?.split?.('_')?.reverse?.()?.[0] || null;

export default getRawObjectId;
